<template>
  <div v-show="show" @click.self="dismiss" class="modal-bg">
    <div id="modal-feedback" class="modal">

      <h1>Palaute</h1>

      <form v-if="showForm" @submit.prevent>

        <div class="form-field" :class="{ required: isRequired }">
          <label for="feedback-context">Konteksti</label>
          <select v-model="isContext" name="feedback-context">
            <option v-for="context in contexts" :key="context" :value="context">{{context}}</option>
          </select>
        </div>

        <div class="form-field">
          <label for="feedback-name">Nimi ja organisaatio</label>
          <input v-model="isName" name="feedback-name" type="text">
        </div>

        <div class="form-field" :class="{ required: isRequired }">
          <label for="feedback-text">Palaute</label>
          <textarea v-model="isText" name="feedback-text" cols="30" rows="10" placeholder="Kirjoita tähän..."></textarea>
        </div>

        <button @click.prevent="addToDatabase" class="btn">Lähetä</button>

        <!-- halutaanko mahdollistaa myös kuvan lähettäminnen????? -->
      </form>

      <!-- tarviiko olla kaksi argumenttia välttämättä -->
      <div v-if="feedback || !showForm">{{this.feedback}}</div>

    </div>
  </div>
</template>

<script>
import db from '@/firebase/init'

export default {
  props: {
    show: {
      type: Boolean
      // default: false
    }
  },

  data () {
    return {
      showForm: true,
      // contexts: ['palaute', 'keihtysehdotus', 'ongelma', 'muu'],
      contexts: this.$store.state.feedbackContexts,
      isContext: null,
      isName: null,
      isText: null,
      isTime: null,
      feedback: null,
      isRequired: false
    }
  },

  created () {
    const escapeHandler = e => {
      if (e.key === 'Escape' && this.show) {
        this.dismiss()
      }
    }
    document.addEventListener('keydown', escapeHandler)
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler)
    })
  },

  methods: {
    dismiss () {
      this.$emit('close')
    },

    addToDatabase () {
      this.timeControl()
      if (this.isContext && this.isText) {
        this.feedback = null
        this.isRequired = false
        db.collection('palaute').add({
          context: this.isContext,
          name: this.isName,
          text: this.isText,
          time: this.isTime
        }).then(() => {
          this.showForm = false
          this.isContext = null
          this.isName = null
          this.isText = null
          this.isTime = null
          this.feedback = 'Palautteesi on lähetetty'
          setTimeout(() => {
            this.feedback = null
            this.dismiss()
          }, 2000)
        })
      } else {
        this.feedback = 'Täytä tarvittavat kentät'
        this.isRequired = true
      }
    },

    timeControl () {
      let time = new Date() // pitäisikö tämä tuhota?!
      let year = time.getFullYear()
      let month = time.getMonth() + 1
      let date = time.getDate()
      let weekdays = ['ma', 'ti', 'ke', 'to', 'pe', 'la', 'su']
      let day = weekdays[time.getDay() - 1]
      this.isTime = `${date}.${month}.${year} (${day})`
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/styles.scss";

$form-border-color: rgb(200, 200, 200);
#modal-feedback {
  label {
    display: block;
    font-size: 0.7rem;
    font-weight: 500;
  }
  input[type="text"],
  input[type="password"],
  input[type="number"],
  input[type="email"], {
    height: 25px;
    padding: 0 8px;
    border: 1px solid $form-border-color;
    border-radius: 5px;
  }
  input {
    &:not([type="checkbox"]) { width: 100%; }
    &::-webkit-outer-spin-button, // for hiding input[type="number"] handle
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
  select {
    width: 100%;
    height: 25px;
  }
  textarea {
    resize: none; // removes the handle
    width: 100%;
    padding: 8px;
    border-radius: 5px;
  }
  input:not([type="file"]), textarea, select {
    outline: none;
    border: 1px solid $form-border-color;
    &:focus { border: 1px solid #002064; }
  }
  button {
    // margin-top: 15px;
    // padding: 0.4rem;
  }
}
</style>
